import React, { useState } from "react";
import { useHistory } from 'react-router-dom'
import { updateUser } from '../redux/userSlice';
import { useSelector, useDispatch } from 'react-redux';
import UserPhoto from "./UserPhoto";
import FavoriteList from "./FavoriteList";

const Account = ({ userPhotos, isLoaded, handleUpdatePhoto, handleDeleteUserPhoto, handleDeleteFavorite, favoriteList, handleAddFavorite }) => {

    const history = useHistory();
    const dispatch = useDispatch();
    const [isShow, setIsShow] = useState(false)
    const user = useSelector((state) => state.user.user)

    const handleEditClick = () => {
        setIsShow(isShow => !isShow)
    }
    
    const [formData, setFormData] = useState({
        username: user.username,
        full_name: user.full_name,
        email: user.email,
        phone: user.phone,
        city: user.city,
        bio: user.bio,
        password: user.password
    });
    
    function handleChange(e) {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    }
    
    function handleSubmit(e) {
        e.preventDefault();
        const token = localStorage.getItem("token");
        fetch("https://fotoset.herokuapp.com/me", {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(formData),
        })
        .then(r => r.json())
        .then(userAccount => {
            dispatch(updateUser(userAccount));
            history.push("/account");
        });
    }
    
    const imageList = userPhotos.map((photo) => {
        return(
            <UserPhoto 
            handleDeleteUserPhoto={handleDeleteUserPhoto}
            key={photo.id}
            id={photo.id}
            image={photo.image}
            ownerId={photo.ownerId}
            camera={photo.camera}
            aperture={photo.aperture}
            shutter_speed={photo.shutter_speed}
            iso={photo.iso}
            lens={photo.lens}
            location={photo.location}
            time={photo.time}
            category={photo.category}
            weather={photo.weather}
            notes={photo.notes}
            handleUpdatePhoto={handleUpdatePhoto}
            />
        )
    })
    
    return user ? (
    <>
        <div className="account-page">
            <div className="account-container">
                <div className="account-left-page">
                    <h2>My Account:</h2>
                    <h3>Post <span>{userPhotos.length}</span></h3>
                    <h3>Favorites <span>{favoriteList.length}</span></h3>
                    <h3>Username: {user.username.toUpperCase()}</h3>
                    <h3>Full Name: {user.full_name.toUpperCase()}</h3>
                    <h3>Email: {user.email.toUpperCase()}</h3>
                    <h3>Phone: {user.phone.toUpperCase()}</h3>
                    <h3>City: {user.city.toUpperCase()}</h3>
                    <h5>Bio: {user.bio}</h5>
                    <button className="edit-btn" onClick={handleEditClick}>{isShow}Edit</button>
                     {isShow ?<div id="profile-form"> 
                        <form onSubmit={handleSubmit}>
                            <label>Username</label><br></br>
                            <input
                                type="text"
                                name="username"
                                placeholder="Enter new username..."
                                className="profile-box"
                                value={formData.username}
                                onChange={handleChange}
                            /><br></br>
                            <label>Full Name</label><br></br>
                            <input
                                type="text"
                                name="full_name"
                                placeholder="Enter new full name..."
                                className="profile-box"
                                value={formData.full_name}
                                onChange={handleChange}
                            /><br></br>
                            <label>Email</label><br></br>
                            <input
                                type="text"
                                name="email"
                                placeholder="Enter new email..."
                                className="profile-box"
                                value={formData.email}
                                onChange={handleChange}
                            /><br></br>
                            <label>Phone Number</label><br></br>
                            <input
                                type="text"
                                name="phone"
                                placeholder="Enter new phone number..."
                                className="profile-box"
                                value={formData.phone}
                                onChange={handleChange}
                            /><br></br>
                            <label>City</label><br></br>
                            <input
                                type="text"
                                name="city"
                                placeholder="Enter new city..."
                                className="profile-box"
                                value={formData.city}
                                onChange={handleChange}
                            /><br></br>
                            <label>Password</label><br></br>
                            <input
                                type="password"
                                name="password"
                                placeholder="Enter new password..."
                                className="profile-box"
                                value={formData.password}
                                onChange={handleChange}
                            /><br></br>
                            <label>Bio</label><br></br>
                            <textarea
                                type="text"
                                name="bio"
                                placeholder="Enter new username..."
                                className="input-area"
                                value={formData.bio}
                                onChange={handleChange}
                            /><br></br>
                            <input type="submit" value="Update Profile" className="btn-update" />
                        </form>
                    </div>: null}
                </div>
                <div className="post-right-side">
                        <h1>My Post:</h1>
                        <hr/>
                    <div className="photo-card-container">
                        {imageList}
                    </div>
                </div>
            </div>
                    <div>
                        <FavoriteList
                        favoriteList={favoriteList}
                        isLoaded={isLoaded}
                        handleAddFavorite={handleAddFavorite}
                        handleDeleteFavorite={handleDeleteFavorite}
                        />
                    </div>
        </div>
    </>
    ) : ""
}

export default Account;